





















































import {
  defineComponent,
  onMounted,
  computed,
  ref,
  watch,
} from "@nuxtjs/composition-api";
import { useBlogsStore, useLayoutsStore } from "~/stores/extensionApi";
import { useUser } from "~/modules/customer/composables/useUser";
import { isMobile } from "~/helpers";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";

const BannerSlider = () => import("~/components/homePage/BannerSlider.vue");
const LayoutService = () => import("~/components/homePage/LayoutService.vue");
const PromotionOnOff = () => import("~/components/homePage/PromotionOnOff.vue");
const PromotionFilter = () =>
  import("~/components/homePage/PromotionFilter.vue");
const BannerCollection = () =>
  import("~/components/homePage/BannerCollection.vue");
const CollectVoucher = () => import("~/components/vouchers/CollectVoucher.vue");
const ProductCate = () => import("~/components/homePage/ProductCate.vue");
const BannerImage = () => import("~/components/homePage/BannerImage.vue");
const FlashSale = () => import("~/components/homePage/FlashSale.vue");
const BlogNews = () => import("~/components/homePage/BlogNews.vue");
const ThreeColumnBanners = () =>
  import("~/components/homePage/ThreeColumnBanners.vue");
const BannerInstagram = () =>
  import("~/components/homePage/BannerInstagram.vue");
const ProductTabsCate = () =>
  import("~/components/homePage/ProductTabsCate.vue");
const BannerText = () => import("~/components/homePage/BannerText.vue");
const NewProduct = () => import("~/components/homePage/NewProduct.vue");

export default defineComponent({
  name: "HomePage",
  components: {
    CollectVoucher,
    LayoutService,
    BannerSlider,
    PromotionOnOff,
    PromotionFilter,
    BannerCollection,
    ProductCate,
    BannerImage,
    FlashSale,
    BlogNews,
    ThreeColumnBanners,
    BannerInstagram,
    ProductTabsCate,
    BannerText,
    NewProduct,
    SkeletonLoader,
  },
  setup() {
    const { user, load: loadUser, isAuthenticated } = useUser();
    const blogsStore = useBlogsStore();
    const layoutsStore = useLayoutsStore();
    const isLoadingBlogs = ref(false);
    const isLoadingLayouts = ref(false);

    onMounted(async () => {
      if (
        !layoutsStore.getLayouts ||
        Object.keys(layoutsStore.getLayouts).length === 0
      ) {
        isLoadingLayouts.value = true;
        await layoutsStore.loadLayouts();
        isLoadingLayouts.value = false;
      }
      if (!blogsStore.getBlogs || blogsStore.getBlogs.length === 0) {
        isLoadingBlogs.value = true;
        await blogsStore.loadBlogs();
        isLoadingBlogs.value = false;
      }
    });

    const filteredLayouts = computed(() => {
      return isMobile()
        ? layoutsStore.getLayoutsByStoreCode("mobile")
        : layoutsStore.getLayoutsByStoreCode("vi");
    });

    const layouts = computed(() => layoutsStore.getLayoutHomePage);
    const blogs = computed(() => blogsStore.getBlogs);

    watch(
      () => isAuthenticated.value,
      async () => {
        if (!user.value) {
          await loadUser();
        }
      }
    );

    return {
      layouts,
      filteredLayouts,
      blogs,
      isLoadingBlogs,
      isLoadingLayouts,
    };
  },
  head() {
    return {
      title: "CANIFA",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Mặc mới mỗi ngày với thời trang CANIFA. Hơn 100+ mẫu quần áo &amp; phụ kiện nam, nữ, trẻ em và bé sơ sinh &quot;lên kệ&quot; hàng ngày. MUA SẮM ONLINE &amp; TẠI CỬA HÀNG!",
        },
         {
          hid: "og:description",
          property: "og:description",
          content:
            "Mặc mới mỗi ngày với thời trang CANIFA. Hơn 100+ mẫu quần áo &amp; phụ kiện nam, nữ, trẻ em và bé sơ sinh &quot;lên kệ&quot; hàng ngày. MUA SẮM ONLINE &amp; TẠI CỬA HÀNG!",
        },
         {
          hid: "og:title",
          property: "og:title",
          content: "CANIFA",
        },
      ],
    };
  },
});
